/**
 * Status names as people read them (PC audit 28.09, point 10). The workspace
 * templates create statuses with English names («In Progress», «Done»), and
 * `move_task` matches statuses by name, so the data keeps them; the screen shows
 * the Russian word. A status someone named themselves is shown as written.
 */
const RUSSIAN: Record<string, string> = {
  todo: "В очереди",
  "in progress": "В работе",
  blocked: "Заблокирована",
  done: "Готово",
  idea: "Идея",
  draft: "Черновик",
  review: "На проверке",
  published: "Опубликовано",
  archived: "В архиве",
  discovery: "Исследование",
  proposal: "Предложение",
  build: "Разработка",
  qa: "Проверка",
  handoff: "Передача",
};

export function statusName(name: string): string {
  return RUSSIAN[name.trim().toLowerCase()] ?? name;
}
